/**
 * Bottom-docked idwiz chat — collapsible thread + suggested actions + input.
 */

export function defaultChatDockExpandedForTab(tab) {
  return tab === "report";
}

export function chatDockSummaryLabel({
  snapBusy = false,
  thinking = false,
  hasAssessment = false,
  headerIdleStatus = "Ready",
}) {
  if (snapBusy) return "Running assessment…";
  if (thinking) return "idwiz is thinking…";
  if (hasAssessment) return "Assessment ready — ask idwiz about your findings";
  if (headerIdleStatus && headerIdleStatus !== "Ready") return headerIdleStatus;
  return "Ask idwiz about your tenant";
}

export default function WorkspaceChatDock({
  expanded = true,
  onToggleExpanded,
  summaryLabel = "Ask idwiz",
  showToggle = true,
  threadRef = null,
  threadChildren = null,
  footerChildren = null,
  /** When false, dock grows to fill (pre-assessment / no tabs). */
  capped = true,
}) {
  return (
    <div
      className={`flex shrink-0 flex-col border-t ${capped && expanded ? "" : capped ? "" : "min-h-0 flex-1"}`}
      style={{
        borderColor: "var(--border)",
        background: "var(--bg-surface)",
        ...(capped && expanded ? { maxHeight: "min(40vh, 420px)" } : {}),
      }}
    >
      {showToggle ? (
        <button
          type="button"
          onClick={() => onToggleExpanded?.()}
          className="flex w-full shrink-0 items-center gap-2 border-b px-3 py-2 text-left transition hover:bg-white/[0.03]"
          style={{ borderColor: "var(--border)" }}
          aria-expanded={expanded}
        >
          <span
            className="text-dim inline-flex w-4 shrink-0 justify-center text-[10px]"
            aria-hidden
          >
            {expanded ? "▾" : "▸"}
          </span>
          <span className="min-w-0 flex-1 truncate text-[12px] text-slate-300">{summaryLabel}</span>
          <span className="text-dim shrink-0 text-[10px]">{expanded ? "Collapse" : "Expand"}</span>
        </button>
      ) : null}

      {expanded ? (
        <div
          ref={threadRef}
          className={`min-h-0 overflow-y-auto overscroll-y-contain ${capped ? "" : "flex-1"}`}
          style={{
            scrollbarGutter: "stable",
            ...(capped ? { maxHeight: "min(24vh, 260px)", minHeight: 72 } : {}),
          }}
        >
          {threadChildren}
        </div>
      ) : null}

      <div
        className="shrink-0 space-y-2 border-t p-3"
        style={{ borderColor: expanded ? "var(--border)" : "transparent" }}
      >
        {footerChildren}
      </div>
    </div>
  );
}
